"use client";
import { jsx as C } from "react/jsx-runtime";
import { memo as s, forwardRef as c } from "react";
import { useSvgIcon as e } from "../useSvgIcon.js";
const i = s(
  c((o, r) => {
    const { monochrome: m, ...t } = o, n = e({
      ...t,
      ref: r
    });
    return /* @__PURE__ */ C(
      "svg",
      {
        width: 24,
        height: 24,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...n(),
        children: /* @__PURE__ */ C(
          "path",
          {
            d: "M25.7393 6.77361C28.9016 11.3501 30.4632 16.5122 29.8794 22.455C29.877 22.4801 29.8637 22.5032 29.8427 22.5183C27.448 24.2492 25.1279 25.2996 22.8403 25.9962C22.8224 26.0015 22.8034 26.0012 22.7858 25.9953C22.7681 25.9895 22.7528 25.9783 22.7419 25.9634C22.2134 25.2396 21.7332 24.4765 21.3125 23.6752C21.2884 23.628 21.3104 23.5712 21.3601 23.5526C22.1228 23.2697 22.848 22.9307 23.5455 22.5294C23.6005 22.4977 23.604 22.4202 23.5532 22.383C23.4052 22.2748 23.2585 22.1611 23.1182 22.0474C23.0919 22.0264 23.0566 22.0223 23.0268 22.0364C18.4982 24.0948 13.5373 24.0948 8.95508 22.0364C8.92533 22.0233 8.88998 22.0278 8.86443 22.0484C8.72443 22.1621 8.57744 22.2748 8.43079 22.383C8.38004 22.4202 8.38424 22.4977 8.43954 22.5294C9.13708 22.9231 9.86228 23.2697 10.6239 23.5539C10.6732 23.5725 10.6967 23.628 10.6722 23.6752C10.2606 24.4776 9.78038 25.2407 9.24208 25.9645C9.21863 25.9938 9.18013 26.0072 9.14373 25.9962C6.86699 25.2996 4.54684 24.2492 2.15215 22.5183C2.1322 22.5032 2.11785 22.4791 2.11575 22.4539C1.62785 17.3135 2.62219 12.1087 6.25204 6.77257C6.26079 6.75845 6.27409 6.74742 6.28949 6.74088C8.07554 5.93404 9.98898 5.34045 11.9889 5.00145C12.0253 4.99594 12.0617 5.01248 12.0806 5.04417C12.3277 5.47481 12.6101 6.02706 12.8012 6.47836C14.9093 6.16141 17.0502 6.16141 19.2024 6.47836C19.3935 6.0367 19.6661 5.47481 19.9122 5.04417C19.9209 5.02845 19.9345 5.01585 19.951 5.00818C19.9674 5.00051 19.986 4.99815 20.0039 5.00145C22.0048 5.34148 23.9183 5.93507 25.7029 6.74088C25.7187 6.74742 25.7316 6.75845 25.7393 6.77361ZM13.8729 16.5473C13.895 15.0277 12.7694 13.7702 11.3564 13.7702C9.95503 13.7702 8.84028 15.0167 8.84028 16.5473C8.84028 18.0776 9.97708 19.3241 11.3564 19.3241C12.7582 19.3241 13.8729 18.0776 13.8729 16.5473ZM23.1766 16.5473C23.1987 15.0277 22.0731 13.7702 20.6605 13.7702C19.2587 13.7702 18.144 15.0167 18.144 16.5473C18.144 18.0776 19.2808 19.3241 20.6605 19.3241C22.0731 19.3241 23.1766 18.0776 23.1766 16.5473Z",
            fill: "var(--icon-color)"
          }
        )
      }
    );
  })
);
i.displayName = "IconDiscord";
export {
  i as IconDiscord
};
